import React from 'react';
import './projects.css'
import course from '../../assets/itcurse.png'
import quiz from '../../assets/quiz.png'
import resale from '../../assets/resale.png'
import { Link } from 'react-router-dom';


const Projects = () => {
    return (
        <div id='projects'>
            <h1 className='mb-4 text-3xl font-semibold text-center lg:mb-10'>My projects</h1>
            <div className='grid grid-cols-1 gap-5 lg:mx-40 lg:grid-cols-3 md:grid-cols-2 lg:gap-20'>
                <div className="w-full shadow-xl card project lg:w-96">
                    <figure className="px-5 pt-5">
                        <img src={course} alt="Shoes" className="h-48 rounded-xl" />
                    </figure>
                    <div className="text-start card-body">
                        <h2 className="card-title projectName">Expert in technology</h2>
                        <a href="https://it-course-3714d.web.app/" target="_blank" rel="noreferrer">Live website</a>
                        <p className='buildwith'>Html   Css  Tailwind-css Javascript  React Express Mongodb</p>
                        <div className="card-actions">
                            <Link to='/itcourse'><button className="btn btn-primary">Details <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="ml-3 h-6 w-6 transform transition-transform group-hover:translate-x-3"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                                />
                            </svg></button></Link>
                        </div>
                    </div>
                </div>
                <div className="w-full mx-auto shadow-xl card lg:w-96 project">
                    <figure className="px-5 pt-5">
                        <img src={quiz} alt="Shoes" className="h-48 w-96 rounded-xl" />
                    </figure>
                    <div className="text-start card-body">
                        <h2 className="card-title">Quiz for programmer</h2>
                        <a href="https://admirable-lily-a4cc4e.netlify.app/" target="_blank" rel="noreferrer">Live website</a>
                        <p className='buildwith'>Html   Css  Tailwind-css Javascript  React</p>
                        <div className="card-actions">
                            <Link to='/quiz'>
                                <button className="btn btn-primary">Details <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="ml-3 h-6 w-6 transform transition-transform group-hover:translate-x-3"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                                    />
                                </svg></button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="w-full mx-auto shadow-xl card lg:w-96 project">
                    <figure className="px-5 pt-5">
                        <img src={resale} alt="Shoes" className="h-48 w-96 rounded-xl" />
                    </figure>
                    <div className=" text-start card-body">
                        <h2 className="card-title">Bus resalling BD</h2>
                        <a href="https://resale-58c70.web.app/" target='_blank' rel="noreferrer">Live website</a>
                        <p className='buildwith'>Html   Css  Tailwind-css Javascript  React Express Mongodb</p>
                        <div className="card-actions">
                            <Link to='/resale'>
                                <button className="btn btn-primary">Details <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="ml-3 h-6 w-6 transform transition-transform group-hover:translate-x-3"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                                    />
                                </svg></button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;